import { del, get, post, put } from '@/api/base-strict'
import { AxiosError, AxiosResponse } from 'axios'
import type { JobFilterSetDTO, JobFilterSetJson } from '@ironsight/types'

const settingsEndpoint = '/api/v1/settings'

export function getJobFilterSets(
  signal: AbortSignal | undefined,
): Promise<AxiosResponse<JobFilterSetJson[], AxiosError>> {
  return get(settingsEndpoint + '/filters', {
    signal,
  })
}

export function createJobFilterSet(filterSet: JobFilterSetDTO) {
  return post(settingsEndpoint + '/filters', {
    data: filterSet,
  })
}

export function deleteJobFilterSet(id: string) {
  return del(settingsEndpoint + '/filters/' + id)
}

export function updateJobFilterSet(id: string, request: JobFilterSetDTO) {
  return put(settingsEndpoint + '/filters/' + id, {
    data: request,
  })
}
